/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromHelpers from './helpers.js'
import React from 'react'
import SupportOnly from 'DesignSystem/SupportOnly/index'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/ApproveAction/Content"
  
}) {
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<TysiaButtonWithText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonWithText`}
 alignSelf="center"
 type="primary"
 size="small"
 onClick={onClick}
 text="Approve"
/>
)}
</SupportOnly>
{children}
</React.Fragment>)
}